import React, {useEffect, useState, useCallback, useRef} from 'react';
import {useForm, useFormState, Controller} from 'react-hook-form';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Dimensions,
  ScrollView,
} from 'react-native';
import {Color, globalFontStyle, globalStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import {globalFormStyle} from '../../../assets/GlobalStyle/globalFormStyle';
import {Button} from '../../../components/core/Button';
import {Input} from '../../../components/core/Input';
import {shallowEqual, useSelector} from 'react-redux';
import {Network} from '../../../utils/network';
import {
  globalConfigurableData,
  globalConst,
  GlobalScreens,
} from '../../../utils/globalConstant';
import TradingFeeSellCDA from '../../portfolio/childComponents/tradingFeeSellCda';
import Slippage from '../../portfolio/childComponents/slippage';
import MultiSlider from '@ptomasroos/react-native-multi-slider';
import {
  debounce,
  trackMoengageEvent,
  RegEx,
  isMobile,
  giveCorrectPrice,
  getReturns,
  getCounterRange,
  getPrice,
  getFieldValidation,
  getModifiedRange,
  getRangeMod,
  defaultRange,
  getReturnsPerShare,
  getSharesOnAddSub,
  getMaxBuySharesByPriceRange,
  getMinBuySharesByPriceRange
} from '../../../utils/commonMethods';
import OutCome from '../../portfolio/childComponents/outcome';
import BuySellBalanceSection from './BuySellBalanceSection';
import {globalImport} from '../../../common/globalImports';
import Width from '../../../assets/Width';
import {ic_minus, ic_plus} from '../../../utils/images';
import FastImage from '../../../common/FastImage';
import BuyReturn from './BuyReturn';
import {useNavigation, useRoute} from '@react-navigation/native';
import FormTextLabel from '../../../commonComponents/FormTextLabel';
import {INDIA} from '../../../utils/constants';
import {Icon} from '@iconify/react';

const SingleOrderBuy = ({
  eventDetails,
  orderStatus,
  onClick,
  orderBookSelectedData,
  invested_amount,
  isDummy,
  isLimit,
  closeSheet,
}) => {
  const route = useRoute();
  const navigation = useNavigation();
  const contestId = route?.params?.contestId;
  const ref = useRef(null);
  const ref1 = useRef(null);
  const [YesSelected, setYesSelected] = useState(
    orderBookSelectedData ? orderBookSelectedData?.callvalue === 'Y' : true,
  );
  const logedIn = useSelector(({utilReducer}) => utilReducer.isAppLogin);

  const {
    control,
    formState: {errors, isValid, isSubmitting},
    handleSubmit,
    reset,
    watch,
    setValue,
  } = useForm({mode: 'onChange'});
  const {dirtyFields, touchedFields} = useFormState({
    control,
  });
  const [sliderData, setSliderData] = useState({});
  const range = getModifiedRange(eventDetails.range);
  const rangeMod = getRangeMod();
  const steps =
    range === rangeMod?.min || range === rangeMod?.mid ? false : true;
  const isRange50 = range === rangeMod?.mid;
  let userInfo = useSelector(({profile}) => profile?.profileData);
  const isSmileEvent = eventDetails?.probe_type === 'promo';
  const walletBalance = parseFloat(
    !isSmileEvent ? userInfo?.maxTradeableAmount : userInfo?.coinsp,
  )?.toFixed(2);
  const isCommunityEvent = eventDetails?.category === 'Community Events';

  let isDisableTradePrivate = false;

  const [isPlacingOrder, setIsPlacingOrder] = useState(false);

  useEffect(() => {
    if (Object.keys(dirtyFields).length <= 0 && !ref1.current) {
      if (!orderBookSelectedData) {
        reset({
          currentPrice: giveCorrectPrice({yPrice: eventDetails?.newYCP}),
          currentShare: eventDetails?.defaultNoOfShares
            ? getSharesOnAddSub(eventDetails?.defaultNoOfShares).toString()
            : getSharesOnAddSub(1).toString(),
          currentAmount: eventDetails?.defaultBuyAmount ?? '100',
        });
      } else {
        setYesSelected(orderBookSelectedData?.callvalue === 'Y');
        reset({
          currentPrice:
            orderBookSelectedData?.callvalue === 'Y'
              ? giveCorrectPrice({yPrice: eventDetails?.newYCP, isFixed: 2})
              : giveCorrectPrice({nPrice: eventDetails?.newNCP, isFixed: 2}),
          currentShare: eventDetails?.defaultNoOfShares
            ? getSharesOnAddSub(eventDetails?.defaultNoOfShares).toString()
            : getSharesOnAddSub(1).toString(),
          currentAmount: eventDetails?.defaultBuyAmount ?? '100',
        });
      }
      if (isLimit) {
        ref1.current = true;
      }
    }
  }, [eventDetails?.newYCP]);

  /*useEffect(() => {
    if (steps && true && isLimit) {
      debouncedSearch(eventDetails?.range, YesSelected, eventDetailsCalls);
    }
  }, []);*/

  const eventDetailsCalls = useSelector(({eventReducer}) => {
    if (isLimit) {
      return eventReducer?.eventDetails?.calls;
    }
    return [];
  }, shallowEqual);

  const watchprice = watch('currentPrice');
  const watchshare = watch('currentShare');
  const watchamount = watch('currentAmount');

  const limitShareUpdate = getSharesOnAddSub(1);

  const onCounterShareUpdate = val => {
    if (logedIn) {
      if (
        val === 'decrement' &&
        +watchshare - limitShareUpdate >= limitShareUpdate
      ) {
        setValue('currentShare', (+watchshare - limitShareUpdate).toString(), {
          shouldValidate: true,
          shouldDirty: true,
        });
      } else if (
        val === 'increment' &&
        +watchshare + limitShareUpdate <= 1000
      ) {
        setValue('currentShare', (+watchshare + limitShareUpdate).toString(), {
          shouldValidate: true,
          shouldDirty: true,
        });
      }
    }
  };

  const counterRange = getCounterRange();

  const onCounterPriceUpdate = val => {
    if (logedIn) {
      if (
        val === 'decrement' &&
        getPrice(+watchprice - counterRange?.addSubVar) >= counterRange?.min
      ) {
        setValue(
          'currentPrice',
          getPrice(+watchprice - counterRange?.addSubVar).toString(),
          {
            shouldValidate: true,
            shouldDirty: true,
          },
        );
      } else if (
        val === 'increment' &&
        getPrice(+watchprice + counterRange?.addSubVar) <= counterRange?.max
      ) {
        setValue(
          'currentPrice',
          getPrice(+watchprice + counterRange?.addSubVar).toString(),
          {
            shouldValidate: true,
            shouldDirty: true,
          },
        );
      }
    }
  };

  const yesNoSelected = isYes => {
    if (isYes) {
      setYesSelected(true);
      reset({
        currentPrice: giveCorrectPrice({yPrice: eventDetails?.newYCP}),
        currentShare: eventDetails?.defaultNoOfShares
          ? getSharesOnAddSub(eventDetails?.defaultNoOfShares).toString()
          : getSharesOnAddSub(1).toString(),
        currentAmount: eventDetails?.defaultBuyAmount ?? '100',
      });
    } else {
      setYesSelected(false);
      reset({
        currentPrice: giveCorrectPrice({nPrice: eventDetails?.newNCP}),
        currentShare: eventDetails?.defaultNoOfShares
          ? getSharesOnAddSub(eventDetails?.defaultNoOfShares).toString()
          : getSharesOnAddSub(1).toString(),
        currentAmount: eventDetails?.defaultBuyAmount ?? '100',
      });
    }
  };
  let globalConfigData = useSelector(
    ({utilReducer}) => utilReducer.globalConfigData,
  );

  const [slippage, setSlippage] = useState(
    globalConfigData?.slippage?.slpType === 'limited' ? true : false,
  );

  const returnCorrectPrice = () => {
    if (dirtyFields.currentPrice || dirtyFields.currentShare) {
      return watchprice;
    } else {
      return YesSelected
        ? giveCorrectPrice({yPrice: eventDetails?.newYCP})
        : giveCorrectPrice({nPrice: eventDetails?.newNCP});
    }
  };

  const fetchData = (nextValue, yesVariable, eventDetailsCalls) => {
    var callvalue = yesVariable ? 'Y' : 'N';
    var calls = eventDetailsCalls;
    var endVariable = false;
    for (var i = 0; i < calls?.length; i++) {
      var call = calls[i];
      var index = i;
      if (
        callvalue !== call['callvalue'] &&
        nextValue === 100 - call['coins'] && // 35 <= 100 - 50
        call['noofcontracts'] > 0
      ) {
        endVariable = true;
        var ind;
        ind = index + 1;
        var nextCall = calls[ind];
        if (nextCall && call['callvalue'] === nextCall['callvalue']) {
          setSliderData({
            avlQty: call['noofcontracts'],
            nextAvlQty: nextCall['noofcontracts'],
            nextAvlPrice: nextCall['coins'],
          });
          break;
        } else {
          setSliderData({
            avlQty: call['noofcontracts'],
          });
          break;
        }
      } else if (
        callvalue !== call['callvalue'] &&
        nextValue <= 100 - call['coins'] &&
        call['noofcontracts'] > 0
      ) {
        endVariable = true;
        setSliderData({
          avlQty: 0,
          nextAvlQty: call['noofcontracts'],
          nextAvlPrice: call['coins'],
        });
        break;
      }
    }
    if (endVariable === false) {
      setSliderData({});
    }
  };
  const debouncedSearch = useCallback(debounce(fetchData, 1000), []);

  useEffect(() => {
    if (
      watchprice &&
      isLimit &&
      eventDetailsCalls &&
      eventDetailsCalls.length > 0
    ) {
      debouncedSearch(getReturns(+watchprice), YesSelected, eventDetailsCalls);
    } else if (isLimit && sliderData?.avlQty) {
      setSliderData({});
    }
  }, [watchprice, YesSelected, isLimit, eventDetailsCalls]);
  let region = userInfo?.region_code ?? 'INDIA';

  const onPlaceOrder = async data => {
    if (!userInfo?.isProfileComplete) {
      isMobile() && closeSheet();
      navigation.navigate('Profile');
      return;
    }
    setIsPlacingOrder(true);
    const inputObj = {
      appVersion: globalConst.appVersion,
      callvalue: YesSelected ? 'Y' : 'N',
      coins: parseFloat(returnCorrectPrice()),
      noofcontracts: (+data?.currentShare).toFixed(1),
      probeid: eventDetails?.id,
      proptionid: YesSelected ? 9 : 10,
      ptype: 'bet',
      tradeType: 'Buy',
      preventSlippage: slippage,
      islimit: isLimit,
      orderamount: parseInt(watchamount),
      range: defaultRange.end,
    };
    try {
      if (!isSubmitting) {
        const res = await Network.buyOrder(inputObj, true);
        trackMoengageEvent('Event Buy', {
          id: eventDetails?.id,
          status: res?.data?.success ? 'successful' : 'failed',
          Side: YesSelected ? 'Yes' : 'No',
          Shares: data.currentShare,
          Category: eventDetails?.category,
          SubCategory: eventDetails?.subcategory,
          price: parseInt(returnCorrectPrice()),
          Type: 'CDA',
          PresentValue: YesSelected
            ? eventDetails?.currentPrice?.newYCP
            : eventDetails?.currentPrice?.newNCP,
          orderboolClicked: orderBookSelectedData != null ? 'Yes' : 'No',
          MarketOpen: new Date(eventDetails?.createdat),
          MarketEnd: new Date(eventDetails?.endsat),
          MarketSettlement: new Date(eventDetails?.settledate),
          SettlementLink: eventDetails?.source,
          isContest: contestId ? true : false,
        });
        orderStatus(res?.data);
      }
    } finally {
      setIsPlacingOrder(false);
    }
  };
  //const logedIn = localStorage.getItem("userMobNumber");

  const handleSlippage = e => {
    // e.preventDefault();
    setSlippage(!slippage);
  };

  const nextQtyFunc = () => {
    setValue('currentPrice', 100 - sliderData?.nextAvlPrice, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  const onCounterPriceUpdateSlider = val => {
    if (
      val === 'decrement' &&
      getPrice(+watchprice - range) >= counterRange?.min
    ) {
      setValue('currentPrice', getPrice(+watchprice - range).toString(), {
        shouldValidate: true,
        shouldDirty: true,
      });
    } else if (
      val === 'increment' &&
      getPrice(+watchprice + range) <= counterRange?.max
    ) {
      setValue('currentPrice', getPrice(+watchprice + range).toString(), {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  };

  const getRoi = () => {
    var roi = 0;

    if (isLimit && watchprice && watchprice > 0) {
      roi = (100 / watchprice).toFixed(2);
    } else if (watchprice && watchamount && watchprice > 0 && watchamount > 0) {
      roi = ((watchamount * 100) / watchprice / watchamount).toFixed(2);
    }

    return roi;
  };

  // const onInputFocus = () => {
  //   if (!touchedFields?.currentShare) {
  //   }
  // };

  const onCounterAmountUpdate = val => {
    if (logedIn) {
      if (val === 'decrement' && +watchamount - 100 >= 1) {
        setValue('currentAmount', (+watchamount - 100).toString(), {
          shouldValidate: true,
          shouldDirty: true,
        });
      } else if (val === 'increment' && +watchamount + 100 <= 200000) {
        setValue('currentAmount', (+watchamount + 100).toString(), {
          shouldValidate: true,
          shouldDirty: true,
        });
      }
    }
  };

  return (
    <View ref={ref}>
      <ScrollView
        style={globalStyle.buySellScroll}
        showsVerticalScrollIndicator={false}>
        <TouchableOpacity activeOpacity={1}>
          <View style={{paddingHorizontal: 15}}>
            <OutCome YesSelected={YesSelected} yesNoSelected={yesNoSelected} />

            <View>
              {isLimit ? (
                <>
                  <View
                    style={{
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      marginBottom: 10,
                      marginTop: 20,
                      alignItems: 'center',
                    }}>
                    <FormTextLabel
                      labelStyles={styles.formTitle}
                      label={'Price'}
                    />
                    {steps && range ? (
                      <View>
                        <Text style={[styles.formTitle, {textAlign: 'right'}]}>
                          {parseFloat(watchprice).toFixed(2)}
                        </Text>
                        <View
                          style={{
                            flexDirection: 'row',
                            justifyContent: 'flex-end',
                          }}>
                          <FormTextLabel
                            labelStyles={globalFontStyle.appFontSmallText}
                            label={'Available Qty: '}>
                            <Text
                              style={{
                                color: GlobalScreens.SingleOrder.highlightColor,
                              }}>
                              {sliderData?.avlQty
                                ? getReturns(sliderData?.avlQty)
                                : 0}
                            </Text>
                          </FormTextLabel>
                        </View>
                      </View>
                    ) : (
                      <View
                        style={{
                          flexDirection: 'row',
                          justifyContent: 'flex-end',
                        }}>
                        {isRange50 ? (
                          <Text
                            style={{
                              color: globalConfigurableData?.primaryTextColor,
                            }}>
                            {watchprice}
                          </Text>
                        ) : (
                          <FormTextLabel
                            labelStyles={{
                              ...globalFontStyle.appFontSmallText,
                              color: globalConfigurableData.primaryTextColor1,
                            }}
                            label={'Available Qty: '}>
                            <Text
                              style={{
                                color: GlobalScreens.SingleOrder.highlightColor,
                              }}>
                              {sliderData?.avlQty
                                ? getReturns(sliderData?.avlQty)
                                : 0}
                            </Text>
                          </FormTextLabel>
                        )}
                      </View>
                    )}
                  </View>
                  {steps && range ? (
                    <View
                      style={{
                        marginBottom: 5,
                      }}>
                      <View
                        style={{
                          marginBottom: 0,
                          flexDirection: 'row',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                        }}>
                        <TouchableOpacity
                          onPress={() =>
                            onCounterPriceUpdateSlider('decrement')
                          }>
                          <Icon 
                            icon="mdi:minus"
                            width={20}
                            height={20}
                            color={globalConfigurableData.primaryTextColor1}
                          />
                        </TouchableOpacity>
                        <Controller
                          control={control}
                          name="currentPrice"
                          render={({field: {value, onChange}}) => (
                            <>
                              {value ? (
                                <MultiSlider
                                  onValuesChange={val => onChange(val[0])}
                                  min={range}
                                  enabledTwo={false}
                                  sliderLength={
                                    !globalImport.isWeb
                                      ? Width.width - 120
                                      : ref?.current?.offsetWidth
                                      ? ref?.current?.offsetWidth - 120
                                      : 200
                                  }
                                  step={range}
                                  snapped={true}
                                  allowOverlap={true}
                                  values={[+value]}
                                  enableLabel={false}
                                  selectedStyle={{
                                    backgroundColor:
                                      GlobalScreens.SingleOrder
                                        .switchSliderSelectedColor,
                                  }}
                                  unselectedStyle={{
                                    backgroundColor:
                                      GlobalScreens.SingleOrder
                                        .switchSliderUnselectedColor,
                                  }}
                                  max={rangeMod?.max - range}
                                  markerStyle={styles.sliderMarkerStyle}
                                  trackStyle={styles.sliderTrackStyle}
                                  customLabel={sliderPosition => {
                                    return (
                                      <View
                                        style={[
                                          styles.sliderLableParent,
                                          {
                                            left:
                                              sliderPosition.oneMarkerLeftPosition -
                                              5,
                                          },
                                        ]}>
                                        <View style={styles.sliderLabelChild}>
                                          <Text
                                            style={[
                                              globalFontStyle.appFontSubTextWeight,
                                              {
                                                color:
                                                  globalConfigurableData.contrastTextColor1,
                                              },
                                            ]}>
                                            {sliderPosition.oneMarkerValue}
                                          </Text>
                                        </View>
                                      </View>
                                    );
                                  }}
                                />
                              ) : null}
                            </>
                          )}
                        />
                        <TouchableOpacity
                          onPress={() =>
                            onCounterPriceUpdateSlider('increment')
                          }>
                          <Icon
                            icon="mdi:plus"
                            width={20}
                            height={20}
                            color={globalConfigurableData.primaryTextColor1}
                          />
                        </TouchableOpacity>
                      </View>
                    </View>
                  ) : (
                    <View style={{marginBottom: 10}}>
                      {!isRange50 ? (
                        <>
                          <View style={{
                            flexDirection: 'row',
                            alignItems: 'center',
                            backgroundColor: globalConfigurableData.cardBgColor,
                            borderRadius: 8,
                            borderWidth: 1,
                            overflow: 'hidden',
                            borderColor: errors?.currentPrice ? Colors.red : globalConfigurableData.borderColor,
                          }}>
                            {!isCommunityEvent && (
                              <>
                                <TouchableOpacity
                                  onPress={() => onCounterPriceUpdate('decrement')}
                                  style={{
                                    height: 46,
                                    width: 46,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                  }}>
                                  <Icon 
                                    icon="mdi:minus"
                                    width={20}
                                    height={20}
                                    color={globalConfigurableData.primaryTextColor1}
                                  />
                                </TouchableOpacity>
                                <View style={{
                                  width: 1,
                                  alignSelf: 'stretch',
                                  backgroundColor: errors?.currentPrice ? Colors.red : globalConfigurableData.borderColor,
                                }} />
                              </>
                            )}
                            <View style={{flex: 1}}>
                              <Input
                                name="currentPrice"
                                placeholder=""
                                control={control}
                                variant="large"
                                disabled={!logedIn || range === rangeMod?.mid}
                                containerStyle={{marginBottom: 0}}
                                style={{borderWidth: 0}}
                                inputStyle={{
                                  borderWidth: 0,
                                  backgroundColor: 'transparent',
                                  textAlign: 'center',
                                }}
                                fullWidth
                                numeric={true}
                                selectTextOnFocus={true}
                                hideError={true}
                                rules={{
                                  required: true,
                                  pattern: {
                                    value: RegEx.tradeNum,
                                    message: 'Please enter a valid amount',
                                  },
                                  ...getFieldValidation(),
                                }}
                              />
                            </View>
                            {!isCommunityEvent && (
                              <>
                                <View style={{
                                  width: 1,
                                  alignSelf: 'stretch',
                                  backgroundColor: errors?.currentPrice ? Colors.red : globalConfigurableData.borderColor,
                                }} />
                                <TouchableOpacity
                                  onPress={() => onCounterPriceUpdate('increment')}
                                  style={{
                                    height: 46,
                                    width: 46,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                  }}>
                                  <Icon
                                    icon="mdi:plus"
                                    width={20}
                                    height={20}
                                    color={globalConfigurableData.primaryTextColor1}
                                  />
                                </TouchableOpacity>
                              </>
                            )}
                          </View>
                          {errors?.currentPrice?.type === 'required' && (
                            <FormTextLabel
                              labelStyles={globalStyle.errorText}
                              label={errors?.currentPrice.message}
                            />
                          )}
                          {(errors?.currentPrice?.type === 'min' ||
                            errors?.currentPrice?.type === 'max') && (
                            <FormTextLabel
                              labelStyles={globalStyle.errorText}
                              label={errors?.currentPrice.message}
                            />
                          )}
                        </>
                      ) : (
                        <FormTextLabel
                          labelStyles={{
                            ...globalFontStyle.appFontSmallText,
                            color: globalConfigurableData.primaryTextColor1,
                          }}
                          label={'Available Qty: '}>
                          <Text
                            style={{
                              color: GlobalScreens.SingleOrder.highlightColor,
                            }}>
                              {sliderData?.avlQty
                                ? getReturns(sliderData?.avlQty)
                                : 0}
                            </Text>
                        </FormTextLabel>
                      )}
                    </View>
                  )}

                  <View
                    style={{
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      marginBottom: 10,
                      marginTop: 10,
                    }}>
                    <FormTextLabel
                      labelStyles={styles.formTitle}
                      label={'Shares'}
                    />
                  </View>
                  <View style={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    backgroundColor: globalConfigurableData.cardBgColor,
                    borderRadius: 8,
                    borderWidth: 1,
                    overflow: 'hidden',
                    borderColor: errors?.currentShare ? Colors.red : globalConfigurableData.borderColor,
                  }}>
                    <TouchableOpacity
                      onPress={() => onCounterShareUpdate('decrement')}
                      style={{
                        height: 46,
                        width: 46,
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}>
                      <Icon
                        icon="mdi:minus"
                        width={20}
                        height={20}
                        color={globalConfigurableData.primaryTextColor1}
                      />
                    </TouchableOpacity>
                    <View style={{
                      width: 1,
                      alignSelf: 'stretch',
                      backgroundColor: errors?.currentShare ? Colors.red : globalConfigurableData.borderColor,
                    }} />
                    <View style={{flex: 1}}>
                      <Input
                        name="currentShare"
                        placeholder=""
                        control={control}
                        variant="large"
                        disabled={!logedIn}
                        containerStyle={{marginBottom: 0}}
                        style={{borderWidth: 0}}
                        inputStyle={{
                          borderWidth: 0,
                          backgroundColor: 'transparent',
                          textAlign: 'center',
                        }}
                        fullWidth
                        numeric={true}
                        hideError={true}
                        rules={{
                          required: true,
                          validate:
                            defaultRange.end === 1
                              ? {
                                  checkShare: value => {
                                    if (value % 10 !== 0) {
                                      return 'Quantity should be in multiples of 10';
                                    } else {
                                      return true;
                                    }
                                  },
                                }
                              : defaultRange.end === 10
                              ? {
                                  checkShare: value => {
                                    if (value % 1 !== 0) {
                                      return 'Quantity should not be decimal';
                                    } else {
                                      return true;
                                    }
                                  },
                                }
                              : defaultRange.end === 100 ? {
                                checkShare: value => {
                                  if (!/^(\d+)?(($)|((\.\d{1})(0+$|$)))/.test(value)) {
                                    return 'Quantity should not have more than one decimal place';
                                  } else {
                                    return true;
                                  }
                                },
                              } : {},
                          min: {
                            value: getMinBuySharesByPriceRange(),
                            message: 'Quantity should be between 0.1 and 1000',
                          },
                          max: {
                            value: userInfo?.mobile === '1987654321' ? getMaxBuySharesByPriceRange(20000) : getMaxBuySharesByPriceRange(),
                            message: 'Quantity should be between 0.1 and 1000',
                          },
                        }}
                      />
                    </View>
                    <View style={{
                      width: 1,
                      alignSelf: 'stretch',
                      backgroundColor: errors?.currentShare ? Colors.red : globalConfigurableData.borderColor,
                    }} />
                    <TouchableOpacity
                      onPress={() => onCounterShareUpdate('increment')}
                      style={{
                        height: 46,
                        width: 46,
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}>
                      <Icon
                        icon="mdi:plus"
                        width={20}
                        height={20}
                        color={globalConfigurableData.primaryTextColor1}
                      />
                    </TouchableOpacity>
                  </View>
                  {errors?.currentShare?.type === 'required' && (
                <FormTextLabel
                  labelStyles={globalStyle.errorText}
                  label={'Quantity should be between 1'}
                  rest={{
                    valueShareMaxHoldings: getMaxBuySharesByPriceRange(),
                    minShares: getMinBuySharesByPriceRange(),
                  }}
                />
              )}
              {(errors?.currentShare?.type === 'min' ||
                errors?.currentShare?.type === 'max') && (
                  <FormTextLabel
                  labelStyles={globalStyle.errorText}
                  label={'Quantity should be between 1'}
                  rest={{
                    valueShareMaxHoldings: getMaxBuySharesByPriceRange(),
                    minShares: getMinBuySharesByPriceRange(),
                  }}
                />
              )}
                  {errors?.currentShare?.type === 'checkShare' && (
                    <FormTextLabel
                      labelStyles={globalStyle.errorText}
                      label={errors?.currentShare.message}
                    />
                  )}
                </>
              ) : (
                <>
                  <View style={[globalFormStyle.tableContainerRowNewForm, {marginBottom: 10, marginTop: 10}]}>
                    <FormTextLabel
                      labelStyles={styles.formTitle}
                      label={'Price'}
                    />
                    <View>
                      <Text style={[styles.formTitle, {textAlign: 'right'}]}>
                        {watchprice}
                      </Text>
                      <FormTextLabel
                        labelStyles={globalFormStyle.fieldRight}
                        label={'At Market'}
                      />
                    </View>
                  </View>
                  <View
                    style={{
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      marginBottom: 10,
                      marginTop: 10,
                    }}>
                    <FormTextLabel
                      labelStyles={styles.formTitle}
                      label={'Amount'}
                    />
                  </View>
                  <View style={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    backgroundColor: globalConfigurableData.cardBgColor,
                    borderRadius: 8,
                    borderWidth: 1,
                    overflow: 'hidden',
                    borderColor: errors?.currentAmount ? Colors.red : globalConfigurableData.borderColor,
                  }}>
                    <TouchableOpacity
                      onPress={() => onCounterAmountUpdate('decrement')}
                      style={{
                        height: 46,
                        width: 46,
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}>
                      <Icon
                        icon="mdi:minus"
                        width={20}
                        height={20}
                        color={globalConfigurableData.primaryTextColor1}
                      />
                    </TouchableOpacity>
                    <View style={{
                      width: 1,
                      alignSelf: 'stretch',
                      backgroundColor: errors?.currentAmount ? Colors.red : globalConfigurableData.borderColor,
                    }} />
                    <View style={{flex: 1}}>
                      <Input
                        name="currentAmount"
                        placeholder=""
                        control={control}
                        variant="large"
                        disabled={!logedIn}
                        containerStyle={{marginBottom: 0}}
                        style={{borderWidth: 0}}
                        inputStyle={{
                          borderWidth: 0,
                          backgroundColor: 'transparent',
                          textAlign: 'center',
                        }}
                        fullWidth
                        numeric={true}
                        rules={{
                          required: true,
                          min: {
                            value: 1,
                          },
                          max: {
                            value: 200000,
                          },
                        }}
                      />
                    </View>
                    <View style={{
                      width: 1,
                      alignSelf: 'stretch',
                      backgroundColor: errors?.currentAmount ? Colors.red : globalConfigurableData.borderColor,
                    }} />
                    <TouchableOpacity
                      onPress={() => onCounterAmountUpdate('increment')}
                      style={{
                        height: 46,
                        width: 46,
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}>
                      <Icon
                        icon="mdi:plus"
                        width={20}
                        height={20}
                        color={globalConfigurableData.primaryTextColor1}
                      />
                    </TouchableOpacity>
                  </View>
                  {errors?.currentAmount?.type === 'max' && (
                    <FormTextLabel
                      labelStyles={globalStyle.errorText}
                      label={
                        'Cannot purchase shares worth more than Rs. 200000 at a time'
                      }
                    />
                  )}
                </>
              )}
            </View>

            <BuySellBalanceSection
              walletBalance={walletBalance}
              slippage={slippage}
              handleSlippage={handleSlippage}
              isShowSlippage={logedIn}
              isLimit={isLimit}
              isSmileEvent={isSmileEvent}
            />

            {/* {steps ? (
              <View style={globalFormStyle.tableContainerRowNewForm}>
                <Text style={globalFormStyle.fieldLeft}>Limit Price</Text>
                <Text style={globalFormStyle.fieldRight}> {watchprice}</Text>
              </View>
            ) : null} */}
            {/* <View style={globalFormStyle.tableContainerRowNewForm}>
              <Text style={globalFormStyle.fieldLeft}>
                {isLimit ? "Total Shares" : "Price"}
              </Text>
              {isLimit ? (
                <Text style={globalFormStyle.fieldRight}>
                  {logedIn
                    ? watchshare
                      ? parseFloat(watchshare)?.toFixed(2)
                      : 0
                    : "-"}
                </Text>
              ) : (
                <Text style={globalFormStyle.fieldRight}> At Market</Text>
              )}
            </View> */}
            <BuyReturn
              isSmileEvent={isSmileEvent}
              investment={
                isLimit
                  ? (watchshare * watchprice)?.toFixed(2)
                  : (1 * watchamount)?.toFixed(2)
              }
              returns={
                isLimit
                  ? getReturnsPerShare(watchshare)?.toFixed(2)
                  : parseFloat(
                      (watchamount * 100) / getReturns(watchprice),
                    )?.toFixed(2)
              }
            />
            {/* <View style={{ ...globalFormStyle.tableContainerRowNewForm }}>
              <Text style={globalFormStyle.fieldLeft}>Potential Returns</Text>
              <Text>
                {isLimit ? (
                  <Text style={globalFormStyle.fieldRight}>
                    {(watchshare * 100).toFixed(2)}
                  </Text>
                ) : (
                  <Text style={globalFormStyle.fieldRight}>
                    {" "}
                    {parseFloat((watchamount * 100) / watchprice)?.toFixed(2)}
                  </Text>
                )}
                <Text style={globalFormStyle.fieldBlue}>
                  &nbsp;(ROI&nbsp;:&nbsp;{getRoi()} X)
                </Text>
              </Text>
            </View> */}
            {logedIn ? <TradingFeeSellCDA configKey={'tfCDABuy'} /> : null}
          </View>
        </TouchableOpacity>
      </ScrollView>
      <View
        style={[
          globalStyle.customBtnParentModalStyle,
          {paddingHorizontal: 15, marginTop: 0},
        ]}>
        <Button
          variant={YesSelected ? (!isValid || isDisableTradePrivate ? 'yes-inactive' : 'yes') : (!isValid || isDisableTradePrivate ? 'no-inactive' : 'no')}
          onPress={() => {
            setTimeout(() => {
              isDummy ? onClick() : handleSubmit(onPlaceOrder)();
            }, globalConst.buttonTimer);
          }}
          disabled={!isValid || isDisableTradePrivate}
          loading={isPlacingOrder}
          loadingText={isDummy ? 'Loading...' : 'Placing Order...'}
          translate={true}
        >
          {isDummy ? 'Next' : 'Confirm Order'}
        </Button>
      </View>
    </View>
  );
};

export default SingleOrderBuy;

const styles = StyleSheet.create({
  btnExternalStyle: {
    borderRadius: 100,
  },
  formTitle: {
    ...globalFontStyle.appFontBody,
    color: globalConfigurableData.primaryTextColor1,
  },
  maxShareText: {
    ...globalFontStyle.appFontSmallTextBold,
    color: GlobalScreens.SingleOrder.highlightColor,
  },
  fieldBottomText: {
    ...globalFontStyle.appFontSmallText,
    color: globalConfigurableData.tertiaryTextColor1,
  },
  sliderMarkerStyle: {
    height: 20,
    width: 20,
    borderRadius: 10,

    top: 2,
    borderWidth: 1,
    backgroundColor: globalConfigurableData.globalThemeColor,
  },
  sliderLabelChild: {
    padding: 4,
    backgroundColor: Color.black,
    borderRadius: 5,
    alignItems: 'center',
  },
  sliderLableParent: {
    height: 30,
    width: 30,
    position: 'absolute',
    bottom: 40,
  },
  sliderTrackStyle: {
    height: 7,
    borderRadius: 5,
  },
});
